import React, { useEffect, useRef, useState } from "react";
import {
  ButtonsWrapper,
  Chip,
  Container,
  More,
  SelectedTeam,
  SelectedText,
  SelectedUsers,
  Tab,
  Tabs,
  TeamName,
  Title,
} from "./styles";
import { Button } from "../Button";
import { PlusLg, Trash, People, XLg, ArrowLeft } from "react-bootstrap-icons";
import { managementPaths } from "./data/paths";
import { useLocation } from "react-router-dom";
import { setActiveModal } from "../../store/slices/modals";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getSelectedUsers } from "../../store/selectors/userManagement";
import { useDispatch } from "react-redux";
import {
  resetSelectedUsers,
  selectTeam,
} from "../../store/slices/userManagement";
import { toast } from "react-toastify";
import { requestAllTeams, setSelectedTeam } from "../../store/slices/teams";
import { getTeams } from "../../store/selectors/teams";
import { DropDown } from "../UserManagementComponents/Teams/DropDown";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import { useAbilityContext } from "../../casl/context";

type Props = {};

const UserManagementMenu: React.FC<Props> = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teams = useSelector(getTeams);
  const menuRef = useRef<any>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const ability = useAbilityContext();

  const selectedUsers = useSelector(getSelectedUsers);

  const selectedUsersCount = selectedUsers.length;

  const resetAll = () => dispatch(resetSelectedUsers());

  useEffect(() => {
    if (!teams.length) {
      dispatch(requestAllTeams({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useOutsideClick(menuRef, () => {
    setMenuOpen(false);
  });

  const handleRemoveTeamUsers = () => {
    const isAllManagersChecked = teams
      ?.find((team) => team?.id === id)
      ?.members?.filter((member) => member.role === "manager")
      ?.every((manager) => selectedUsers.includes(manager.id));

    if (isAllManagersChecked) {
      dispatch(setActiveModal({ id: "lastManagerDeclined" }));
    } else {
      dispatch(setSelectedTeam(id));
      dispatch(setActiveModal({ id: "removeTeamUsers" }));
    }
  };

  return (
    <Container>
      {selectedUsersCount ? (
        <SelectedUsers>
          <XLg onClick={resetAll} />
          <SelectedText> {selectedUsersCount} selected </SelectedText>
        </SelectedUsers>
      ) : id ? (
        <SelectedTeam>
          <ArrowLeft onClick={() => navigate("/management/teams")} />
          <TeamName>{teams?.find((item) => item?.id === id)?.name}</TeamName>
          {teams
            ?.find((item) => item?.id === id)
            ?.datasets?.map((dataset) => (
              <Chip>{dataset.name}</Chip>
            ))}
          <div style={{ position: "relative" }} ref={menuRef}>
            <More
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(selectTeam(id))
                dispatch(setSelectedTeam(id))
                setMenuOpen(!menuOpen);
              }}
            />
            {menuOpen && <DropDown id={id} menuOpen={menuOpen} isTeamPage />}
          </div>
        </SelectedTeam>
      ) : (
        ability.can('read', 'users') ? (<Tabs>
          {managementPaths?.map((item) => (
            <Tab $selected={pathname === item.path} to={item.path}>
              {item.icon} {item.title}
            </Tab>
          ))}
        </Tabs>
        ) : (
          <Title>
            My Teams
          </Title>
        )

      )}
      {pathname === "/management/users" && (
        <>
          {!!selectedUsersCount ? (
            <ButtonsWrapper>
              {ability.can('delete', 'users') && (
                <Button
                  onClick={() => {
                    dispatch(setActiveModal({ id: "removeUsers" }));
                  }}
                  variant={"danger"}
                  icon={<Trash />}
                  name="Delete"
                  size={"large"}
                />
              )}
              {ability.can('update', 'teams') && (
                <Button
                  onClick={() => {
                    if (selectedUsers.length >= 50) {
                      toast.warn("You can add maximum 50 members to team");
                      return;
                    }
                    dispatch(setActiveModal({ id: "addToTeamModal" }));
                  }}
                  variant={"secondary"}
                  icon={<People />}
                  name="Add to Teams"
                  size={"large"}
                />
              )}
            </ButtonsWrapper>
          ) : (
            <Button
              onClick={() => {
                dispatch(setActiveModal({ id: "invitePeopleModal" }));
              }}
              variant={"secondary"}
              icon={<PlusLg />}
              name="Invite People"
              size={"large"}
            />
          )}
        </>
      )}

      {pathname.includes("/management/teams") && (
        <>
          {!selectedUsersCount ? (
            id ? (
              ability.can('manage', 'teams') && (
                <Button
                  onClick={() => {
                    dispatch(setActiveModal({ id: "inviteToTeamModal" }));
                  }}
                  variant={"secondary"}
                  icon={<PlusLg />}
                  name="Invite People"
                  size={"large"}
                />
              )
            ) : (
              ability.can('create', 'teams') && !!teams?.length && (
                <Button
                  onClick={() => {
                    dispatch(setActiveModal({ id: "createTeamModal" }));
                  }}
                  variant={"secondary"}
                  icon={<PlusLg />}
                  name="Create Team"
                  size={"large"}
                />
              )
            )
          ) : (
            <Button
              onClick={handleRemoveTeamUsers}
              variant={"danger"}
              name="Remove from Team"
              size={"large"}
            />
          )}
        </>
      )}
    </Container>
  );
};

export default UserManagementMenu;
